module.exports = __webpack_public_path__ + "static/media/profile.a34fd627.jpg";